import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Component, Input, OnInit } from '@angular/core';
import { CurrencyMaskInputMode } from "ngx-currency";
import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { EditExpenseModalComponent } from '../../employee/expense/edit-expense-modal/edit-expense-modal.component';
import { UtilityService } from '../../../core/services/utility.service';
import { HomeService } from './../../../pages/home/services/home.service';
import {
  PdfViewerComponent, LinkAnnotationService, BookmarkViewService, MagnificationService,
  ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
  AnnotationService, TextSearchService, TextSelectionService,
  PrintService, FormDesignerService, FormFieldsService, ValidateFormFieldsArgs
} from '@syncfusion/ej2-angular-pdfviewer';
@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
  providers: [LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, SignatureFieldSettings,
    AnnotationService, TextSearchService, TextSelectionService,
    PrintService, FormDesignerService, FormFieldsService]
})
export class ConfirmationModalComponent implements OnInit {
  @Input() data: any;
  @Input() selectedEmployee: any;
  @Input() errorMsg: string;
  public pdfviewerControl: PdfViewerComponent;
  expenseData: { [key: string]: any } = {};
  options: { [key: string]: any } = {};
  currencySymbol: string;
  format: string;
  portalSettings: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  extenion: string;
  showViewer: boolean;
  isOpen: any[];
  savedFiles: any[];
  newFiles: any[];
  expensePostingType: string;
  attachmentList: any[];
  bdatePickerOptions: { dateInputFormat: string; containerClass: string; showTodayButton: boolean; showClearButton: boolean; clearPosition: string; showWeekNumbers: boolean };
  mobileMode: boolean;
  catList: any[] = [];
  showExpenseCategory: boolean = false;
  service: any;

  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, portalSettingsService: PortalSettingsService, employeeInfoService: EmployeeInfoService,
    private employeeService: EmployeeService, private utilityService: UtilityService, private homeService: HomeService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.format = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.service = "/Api/PdfViewer";
    this.bdatePickerOptions = { dateInputFormat: this.format.toUpperCase(), containerClass: "theme-blue", showTodayButton: true, showClearButton: true, clearPosition: "left", showWeekNumbers: false };
    this.formData.selectedAttachment = {}
    this.getExpenseModel();
    this.getCatg();
    this.showExpenseCategory = this.portalSettings.ExShowExpenseCategory.ConfigValue == "1";
    var currencyFormatSymbols = this.portalSettings.CurrencyFormatPerPRCo.ConfigValue;
    this.expensePostingType = this.portalSettings.ExpensePostingType.ConfigValue;
    this.currencySymbol = "$";
    if (currencyFormatSymbols && currencyFormatSymbols.trim() != "") {
      currencyFormatSymbols.split(",").forEach((val: string) => {
        var arrayEntry = val.split(":");
        var currencyObject = { PRCo: parseInt(arrayEntry[0]), Currency: arrayEntry[1] }
        if (this.employeeInfo && currencyObject.PRCo == this.employeeInfo.PRCo) {
          this.currencySymbol = currencyObject.Currency;
        }
      });
    }
    this.mobileMode = this.mobileAndTabletcheck();
    this.options = { align: 'left', prefix: this.currencySymbol, precision: 2, nullable: true, inputMode: CurrencyMaskInputMode.NATURAL };
  }

  getExpenseModel() {
    var userKeyID = this.selectedEmployee ? this.selectedEmployee.UserKeyID : null;
    this.employeeService.getPendingInformationByID(userKeyID, this.data.newID).then((response: any) => {
      this.expenseData = response[0];
      this.expenseData.ExpenseDate = new Date();
      this.getAttachment();
    })
  }

  getCatg() {
    this.employeeService.getCategory().then((response: any) => {
      if (response != null) {
        this.catList = [];
        response.forEach((val: any) => {
          if (val.IsActive)
            this.catList.push(val);
        });
      }
      });
    this.closeModal();
  }

  mobileAndTabletcheck() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }

  attachmentChange() {
    this.extenion = this.formData.selectedAttachment.AttachmentFileName.substr(this.formData.selectedAttachment.AttachmentFileName.lastIndexOf("."), this.formData.selectedAttachment.AttachmentFileName.length);
    if (this.utilityService.checkFileExtension(this.extenion)) {
      this.showViewer = true;
      this.homeService.getPdfData(this.formData.selectedAttachment.FileAttachmentID).then((response: any) => {
        var pdfviewer = (<any>document.getElementById('pdfViewerConfirmation')).ej2_instances[0];
        pdfviewer.toolbar.showToolbarItem(new Array("SubmitForm"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("OpenOption"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("CommentTool"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("PrintOption"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("AnnotationEditTool"), false);
        pdfviewer.toolbar.showToolbarItem(new Array("FormDesignerEditTool"), false);
        pdfviewer.documentPath = "data:application/pdf;base64," + (response);
        pdfviewer.downloadFileName = this.formData.selectedAttachment.AttachmentFileName.substring(0, this.formData.selectedAttachment.AttachmentFileName.indexOf('.')) + ".pdf";
      }).catch((error: any) => {

      });
    } else {
      this.showViewer = false;
    }
  }

  getAttachment() {
    this.savedFiles = [];
    this.newFiles = [];
    this.employeeService.getLineAttachments(this.expenseData.ExpenseItemID).then((response: any) => {
      this.savedFiles = response;
      if (this.savedFiles && this.savedFiles.length > 0) {
        this.formData.selectedAttachment = this.savedFiles[0];
      }
      this.attachmentList = [];
      response.forEach((val: { AttachmentFileName: string; }) => {
        var tempExten = val.AttachmentFileName.slice(val.AttachmentFileName.lastIndexOf("."), val.AttachmentFileName.length);
        if (tempExten.toLowerCase() == ".jpg" || tempExten.toLowerCase() == ".jpeg" || tempExten.toLowerCase() == ".png" || tempExten.toLowerCase() == ".tif" || tempExten.toLowerCase() == ".tiff")
          this.attachmentList.push(val);
        this.attachmentChange();
      });
    });
  }

  openEditExpenseModal() {
    this.openModal();
    this.employeeService.insertUpdateExpenseItem(
      this.expenseData.ExpenseItemID, null, this.expenseData.Description, this.expenseData.Amount,
      null, null, null, null, (this.selectedEmployee == null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID), null, null, null, null, null, null, null, null, null, null, moment(this.expenseData.ExpenseDate, this.format.toUpperCase()).format("YYYY-MM-DD")
    ).then((reponse: any) => {
      this.closeModal();
      let modalRef = this.modalService.open(EditExpenseModalComponent,{size: 'lg', backdrop:'static'});
      modalRef.componentInstance.data = this.expenseData;
      modalRef.componentInstance.mode = 'edit';
      modalRef.componentInstance.selectedEmployee = this.selectedEmployee;
      modalRef.componentInstance.where = 'submit';
      modalRef.result.then((result) => {
          this.activeModal.close();
      }).catch((res) => { });
    });
  };

  cancelClicked() {
    this.openModal();
    this.employeeService.insertUpdateExpenseItem(
      this.expenseData.ExpenseItemID, this.expenseData.ExpenseCatgID, this.expenseData.Description, this.expenseData.Amount, this.expenseData.TaxAmount, this.expenseData.Vendor, this.expenseData.JCCo,
      (this.expenseData.Job != null ? this.expenseData.Job.DatabaseValue : null), (this.selectedEmployee == null ? this.data.SubmittedByUserKeyID : this.selectedEmployee.UserKeyID), this.expenseData.CustomerName,
      this.expenseData.Phase, (this.expensePostingType == "P" ? null : this.expenseData.GLCo), (this.expensePostingType == "P" ? null : this.expenseData.GLAcct), this.expenseData.SMCo, this.expenseData.SMWorkOrder,
      this.expenseData.EMCo, this.expenseData.Units, this.expenseData.UM, this.expenseData.UnitCost, moment(this.expenseData.ExpenseDate, this.format.toUpperCase()).format("YYYY-MM-DD"),
      this.expenseData.ReimburseOrMileage, this.expenseData.CustomerCount, this.expenseData.OurFirmCount, this.expenseData.Note, this.expenseData.JCCType, null, this.expenseData.TaxCode, this.expenseData.PO,
      this.expenseData.POItem, this.expenseData.SL, this.expenseData.SLItem, this.expenseData.WO, this.expenseData.WOItem, this.expenseData.Equip, this.expenseData.CostCode, this.expenseData.EMCType,
      this.expenseData.CompType, this.expenseData.Component, this.expenseData.INCo, this.expenseData.Loc, this.expenseData.Material, this.expenseData.Scope, this.expenseData.POItemLine, this.expenseData.SMCostType,
      this.expenseData.ItemType, this.expenseData.EarnCode, null, this.expenseData.TaxType
    ).then((reponse: any) => {
      this.activeModal.close('close');
      this.closeModal();
    });
  }

  openModal() {
    document.getElementById('modalShare').style.display = 'block';
    document.getElementById('fadeShare').style.display = 'block';
  }

  closeModal() {
    document.getElementById('modalShare').style.display = 'none';
    document.getElementById('fadeShare').style.display = 'none';
  }

}

